<app-header></app-header>
<!-- Master_Router_Outlet -->
<div class="master_router_outlet">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
